import React from 'react';
import { Button, Modal, Loader, Dimmer, Table } from 'semantic-ui-react';
import currencyHelper from '../../helpers/currencyHelper';
import { I18n } from 'react-redux-i18n';

const DonationDetailsTable = ({ amount, currency, firstName, lastName, email, receiptNumber }) => {
  const donorName = [firstName, lastName].filter(Boolean).join(' ');
  return (
    <Table basic="very" compact="very" style={{ marginBottom: '16px' }}>
      <Table.Body>
        <Table.Row>
          <Table.Cell style={{ fontWeight: 'bold' }}>
            {I18n.t('donation.refund-window.details.amount')}
          </Table.Cell>
          <Table.Cell>{currency} {currencyHelper.formatCurrency(amount, currency)}</Table.Cell>
        </Table.Row>
        {donorName && (
          <Table.Row>
            <Table.Cell style={{ fontWeight: 'bold' }}>
              {I18n.t('donation.refund-window.details.donor')}
            </Table.Cell>
            <Table.Cell>{donorName}</Table.Cell>
          </Table.Row>
        )}
        {email && (
          <Table.Row>
            <Table.Cell style={{ fontWeight: 'bold' }}>
              {I18n.t('donation.refund-window.details.email')}
            </Table.Cell>
            <Table.Cell>{email}</Table.Cell>
          </Table.Row>
        )}
        <Table.Row>
          <Table.Cell style={{ fontWeight: 'bold' }}>
            {I18n.t('donation.refund-window.details.receipt-number')}
          </Table.Cell>
          <Table.Cell>{receiptNumber}</Table.Cell>
        </Table.Row>
      </Table.Body>
    </Table>
  );
};

const PlacehubWarning = () => (
  <div style={{ color: 'red', fontWeight: 'bold', marginBottom: '10px' }}>
    {I18n.t('donation.refund-window.placehub-warning')}
  </div>
);

const RefundModal = ({
  amount,
  currency,
  email,
  firstName,
  lastName,
  receiptNumber,
  isRefunding,
  isLoadingRelated,
  showPlacehubWarning,
  onConfirm,
  onClose
}) => {
  return (
    <Modal.Content>
      {isLoadingRelated && (
        <Dimmer active inverted>
          <Loader />
        </Dimmer>
      )}
      {!isLoadingRelated && showPlacehubWarning && <PlacehubWarning />}
      <DonationDetailsTable
        amount={amount}
        currency={currency}
        firstName={firstName}
        lastName={lastName}
        email={email}
        receiptNumber={receiptNumber}
      />
      {I18n.t('donation.refund-modal.confirmation')}
      <div
        className="button-wrapper align-right"
        style={{ marginTop: '10px' }}
      >
        <Button
          primary
          onClick={onConfirm}
          style={{ marginRight: '10px' }}
          loading={isRefunding}
          disabled={isRefunding || isLoadingRelated}
        >
          {I18n.t('donation.refund-modal.yes')}
        </Button>
        <Button onClick={onClose}>{I18n.t('donation.refund-modal.no')}</Button>
      </div>
    </Modal.Content>
  );
};

export default RefundModal;
